
import { defineComponent } from 'vue';

export default defineComponent({
  props: {
    button: String,
  },
  data() {
    return {
      search: '',
      show: false,
    };
  },
  methods: {
    emitSearch() {
      this.$emit('search', this.search);
    },
    emitShowPopup() {
      this.$emit('popup', this.show);
    },
  },
});
